module.exports = __webpack_public_path__ + "static/media/marca_poupatempo_balcao_unico_govbr_inverted.7db30a50.png";